<template>
  <router-link to="/agenzie" class="ic-nav__link">Agenzie</router-link>
</template>

<script>
export default {
  // "Agenzie" → the agencies page (/agenzie). A plain router-link: real
  // href (crawlers, open in a new tab) and aria-current on the page itself.
  // The old home anchor (/#agenzie) still scrolls to the home band (Home.vue).
  name: 'AgencyNavLink',
}
</script>

<style scoped>
.ic-nav__link {
  font-size: 16px;
  font-weight: 500;
  color: var(--ic-ink, #1e1e1e);
  white-space: nowrap;
  padding: 10px 16px;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 0.18s ease;
}
/* Pill hover: same beige as the listings "Ordina" button hover; the same pill
   stays on while you are on the agencies page. */
.ic-nav__link:hover,
.ic-nav__link.router-link-exact-active { background-color: #f2efe7; }
/* La visibilità responsive è governata dal layout ospite (ImmaginaHeader:
   sotto 1024px il link vive nel drawer mobile, non più nascosto qui). */
</style>
